import React, { useState } from "react";
import { get, isEmpty, toLower } from "lodash";
import { recordCount } from "../../../../../../utils";
import { useDeepEffect } from "../../../../../../abstracts";
import { FormControlSearch } from "../../../../../../components";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { getInvestmentsByPlanId } from "../../../../../../services";

const AddInvestmentSlider = ({
  index,
  fields,
  values,
  showPopup,
  setFieldValue,
}) => {
  const planId = get(values, "planId", 0);
  const transferData = get(values, "transferSourceDetails", []);
  const [investmentData, setInvestmentData] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [count, setCount] = useState(0);

  useDeepEffect(() => {
    getInvestmentsByPlanId(planId)
      .then((res) => {
        let temp = res.map((item) => {
          return transferData[index].transferInvestmentDetails.some(
            (_) => _.investmentId === item.investmentId
          ) === true
            ? { ...item, checked: true }
            : { ...item, checked: false };
        });
        setCount(temp.filter((_) => _.checked === true).length);
        setInvestmentData(temp);
        setFilteredValues(temp);
      })
      .catch((err) => {
        //err
      });
  }, []);

  const search = (val) => {
    setFilteredValues(
      investmentData.filter((item) => {
        return search === "" || toLower(item.name).indexOf(toLower(val)) !== -1;
      })
    );
  };

  const onChange = (id) => {
    let temp = investmentData.map((itm) => {
      if (itm.investmentId === id) return { ...itm, checked: !itm.checked };
      return itm;
    });
    setCount(temp.filter((_) => _.checked === true).length);
    setInvestmentData(temp);
    setFilteredValues(
      filteredValues.map((itm) => {
        if (itm.investmentId === id) return { ...itm, checked: !itm.checked };
        return itm;
      })
    );
  };

  const onAddClick = () => {
    setFieldValue(
      `${fields.transferSourceDetails}[${index}].${fields.transferInvestmentDetails}`,
      [
        ...transferData[index].transferInvestmentDetails.filter((_) =>
          get(
            investmentData.find((inv) => inv.investmentId === _.investmentId),
            "checked",
            false
          )
        ),
        ...investmentData
          .filter(
            (x) =>
              !transferData[index].transferInvestmentDetails
                .map((y) => y.investmentId)
                .includes(x.investmentId) && x.checked
          )
          .map((itm) => {
            return {
              id: 0,
              investmentId: itm.investmentId,
              investmentName: itm.name,
              currentPercentage: 0,
              amount: null,
              percentage: 0,
            };
          }),
      ]
    );
    showPopup();
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="d-flex flex-column">
          <p className="ft-16 fw-500 mb-1">Add Investment</p>
          <p className="ft-12 fw-400 grey-text">
            {recordCount(investmentData.length)} investments
          </p>
        </div>
        <div>
          <Button
            variant="secondary"
            className="mr-3"
            onClick={() => showPopup()}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={onAddClick}>
            Add Investment
          </Button>
        </div>
      </div>
      <div className="border-top" />
      <div className="search-bar-investment mt-16">
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text className="plan-search-button">
              <Image src="/assets/icons/svg/search.svg" width="14px" />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControlSearch
            type="search"
            placeholder="Search"
            onChange={(e) => {
              search(e.target.value);
            }}
          />
        </InputGroup>
      </div>
      <p className="ft-12 fw-400 grey-text mt-2">
        {recordCount(count)} investments added
      </p>
      {!isEmpty(filteredValues) &&
        filteredValues.map((item, index) => {
          return (
            <div className="d-flex justify-content-start mb-4 border-bottom">
              <Form.Check
                name={`investment${index}`}
                type="checkbox"
                label=""
                id={`investment${index}`}
                onChange={() => onChange(item.investmentId)}
                checked={item.checked}
              />
              <span className="ft-14 ml-2 mb-2">{item.name}</span>
            </div>
          );
        })}
    </>
  );
};

export default AddInvestmentSlider;
